export function showMenu() {
  var menuExpandible = document.querySelector(".menu-expandible");
  menuExpandible.classList.toggle("leftMenu");
}
